import {useState,useEffect} from 'react'
import {envAwarePost} from '../../util/util'
import Form from 'react-bootstrap/Form'

const DeductSessionCheck = ({client_id,checked,onChange,label})=>{
	const [status,setStatus] = useState('pending')
	const [remainingSessions,setRemainingSessions] = useState(0)
	useEffect(()=>{
		envAwarePost('api/sessions/',{
			action:'getNumSessionCredits',
			client_id
		}).then(res=>{
			setStatus('idle')
			setRemainingSessions(res.data.num_sessions)
		})
	},[])
	if(status==='pending') return (
		<div className="text-right">
			<small>Checking if client has sessions</small>
		</div>
	)
	return (
		<div className="text-right">
			<Form.Check 
				disabled={remainingSessions===0}
				onChange={onChange}
				checked={checked}
				id="deduct-session-check"
				label={label}
			/>
			{remainingSessions===0&&
				<small className="d-block">Client has no remaining sessions</small>
			}
		</div>
	)
}

export default DeductSessionCheck